import React from "react";
import Navbar from "../../components/user/navbar";
import Footer from "../../components/main/footer";
import Avatar from "../../images/avatar.png";
import {
  Grid2,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Box,
} from "@mui/material";
import Subscription from "../../images/subscription.png";
import { Link } from "react-router-dom";

const UserSpace = () => {
  return (
    <div>
      <Navbar />
      <Grid2
        container
        bgcolor="#f8f9fc"
        flexDirection="column"
        alignItems="center"
        flexWrap="wrap"
        padding="30px"
      >
        <Grid2 marginBottom="20px">
          <Typography fontFamily="General Sans Regular" variant="h3" fontWeight="700" fontSize="30px">
            SmartCandidate
          </Typography>
        </Grid2>
        <Grid2 container justifyContent="row">
          <Grid2 container flexDirection="row" gap={5} padding="30px">
            <Card
              component={Link}
              to={"plan"}
              sx={{
                maxWidth: 300,
                transition: "transform 0.3s ease",
                "&:hover": {
                  transform: "translateY(-10px)",
                  boxShadow: "0px 6px 10px rgba(0, 0, 0, 0.1)",
                },
              }}
            >
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                padding="20px"
              >
                <CardMedia
                  component="img"
                  sx={{ height: 100, width: 100 }}
                  image={`${Subscription}`}
                />
              </Box>
              <CardContent>
                <Typography fontFamily="General Sans Regular" gutterBottom variant="h5" component="div">
                  Plan
                </Typography>
                <Typography fontFamily="General Sans Regular" variant="body2" color="inherit">
                  Vérifiez votre solde restant et suivez votre utilisation
                  avec notre gestion de plan intuitive. Restez informé sur vos
                  habitudes d'utilisation et rechargez facilement votre plan pour garantir
                  un accès ininterrompu à nos services.
                </Typography>
              </CardContent>
            </Card>
          </Grid2>
          <Grid2 container flexDirection="row" gap={5} padding="30px">
            <Card
              component={Link}
              to={"profile"}
              sx={{
                maxWidth: 300,
                transition: "transform 0.3s ease",
                "&:hover": {
                  transform: "translateY(-10px)",
                  boxShadow: "0px 6px 10px rgba(0, 0, 0, 0.1)",
                },
              }}
            >
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                padding="20px"
              >
                <CardMedia
                  component="img"
                  sx={{ height: 100, width: 100 }}
                  image={`${Avatar}`}
                />
              </Box>
              <CardContent>
                <Typography fontFamily="General Sans Regular" gutterBottom variant="h5" component="div">
                  Profile
                </Typography>
                <Typography fontFamily="General Sans Regular" variant="body2" color="inherit">
                  Accédez à votre profil personnel pour consulter les informations détaillées
                  sur votre compte, gérer vos préférences et mettre à jour vos données personnelles.
                </Typography>
              </CardContent>
            </Card>
          </Grid2>
        </Grid2>
      </Grid2>

      <Footer />
    </div>
  );
};

export default UserSpace;
